<template>
  <div
    class="coupon-pop"
    v-show="dialogVisible && couponTuijianData.state == 0"
  >
    <div class="coupon-bg">
      <div class="receive-condition">
        <img
          style="width: 20px"
          src="@/assets/imgs/couponImg/line-left.png"
          alt="线"
        />
        <span v-if="couponTuijianData.get_condition == 2" class="receive-text">
          领取条件：观看满
          <span style="color: #ff7d78; font-size: 14px">{{
            `${lookTime}/${couponTuijianData.watch_time}`
          }}</span>
          分钟
        </span>
        <span v-else class="receive-text"> 领取条件：观看至下播 </span>
        <img
          style="width: 20px"
          src="@/assets/imgs/couponImg/line-right.png"
          alt="线"
        />
      </div>
      <!-- 优惠券 -->
      <div class="coupon_con">
        <div class="num-con">
          <span v-if="couponTuijianData.type == 1" class="tip">¥</span>
          <span class="value-num">{{
            Number(couponTuijianData.face_value)
          }}</span>
          <span class="tip" v-if="couponTuijianData.type == 2">折</span>
        </div>
        <!-- 右侧文字 -->
        <div class="right-con">
          <span class="name-text">{{ couponTuijianData.name }}</span>
          <div class="time-con">
            <span class="time-text">{{
              handleTime(couponTuijianData.start_time)
            }}</span>
            <span class="time-text">-</span>
            <span class="time-text">{{
              handleTime(couponTuijianData.end_time)
            }}</span>
          </div>
        </div>
      </div>

      <!-- 使用规则 -->
      <div
        class="rule-con"
        :class="{ 'has-rule': couponTuijianData.description }"
      >
        <span class="rule-text" v-if="couponTuijianData.description"
          >使用规则：{{ couponTuijianData.description }}</span
        >
        <span v-else>数量有限，赶紧参与吧</span>
      </div>
      <!-- 底部按钮 -->
      <div class="bottom-btn" @click="closePop"></div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close" style="text-align: center; margin-top: 16px">
      <img
        src="@/assets/imgs/couponImg/close_img.png"
        style="cursor: pointer"
        @click="closePop"
        alt=""
        srcset=""
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["dialogVisible", "couponTuijianData", "lookingTime"],
  data() {
    return {
      lookTime: 0,
      lookNum: 0,
    };
  },
  computed: {},
  watch: {
    lookingTime(newV) {
      if (
        newV &&
        this.couponTuijianData.state == 0 &&
        this.couponTuijianData.get_condition == 2
      ) {
        const totalTime = newV;
        if (Math.floor(totalTime / 60) <= this.couponTuijianData.watch_time) {
          if (Math.floor(totalTime / 60) == this.couponTuijianData.watch_time) {
            if (this.lookNum === 0 && !this.couponTuijianData.is_satisfy) {
              this.$emit("timeAchieved");
              this.lookNum += 1;
            }
            this.lookTime = this.couponTuijianData.watch_time;
          } else {
            this.lookTime =
              Math.floor(totalTime / 60) < 0 ? 0 : Math.floor(totalTime / 60);
          }
        }
      }
    },
  },
  mounted() {},
  methods: {
    handleTime(time) {
      if (time) {
        const timeArr = time.split(" ");
        const newTimeArr = timeArr[0].split("-");
        return newTimeArr.join(".");
      }
    },
    // 关闭弹窗
    closePop() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.coupon-pop {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: auto;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9990;
}
.coupon-bg {
  width: calc(562px / 2);
  height: calc(652px / 2);
  background: url("~@/assets/imgs/couponImg/no_coupon.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.receive-condition {
  width: 100%;
  height: 30px;
  margin-top: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
.line {
  color: #969798;
}
.receive-text {
  color: #822503;
  font-size: 14px;
  margin: 0 6px;
}
.coupon_con {
  width: 245px;
  height: 112px;
  position: absolute;
  top: 98px;
  left: 18px;
  display: flex;
}
.num-con {
  width: 84px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tip {
  font-size: 14px;
  height: 28px;
  line-height: 36px;
  font-family: Source Han Sans CN, Source Han Sans CN-700;
  font-weight: 700;
  color: #fff;
  margin-bottom: -2px;
}
.value-num {
  color: #ffffff;
  font-size: 30px;
  font-family: Source Han Sans CN, Source Han Sans CN-500;
  font-weight: 500;
}

.right-con {
  margin-left: 10px;
  width: 150px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.name-text {
  font-size: 14px;
  font-family: PingFang SC;
  color: #fff;
  line-height: 16px;
  margin-bottom: 10px;
}
.time-text {
  font-size: 12px;
  font-family: PingFang SC;
  color: #fff;
}
.rule-con {
  width: 100%;
  height: 48px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 202px;
  padding: 0 18px;
  box-sizing: border-box;
}
.has-rule {
  justify-content: flex-start;
  line-height: 16px;
}
.rule-text {
  color: #822503;
  font-size: 12px;
}
.bottom-btn {
  position: absolute;
  bottom: 24px;
  width: 201px;
  height: 44px;
  border-radius: 22px;
  z-index: 1;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/couponsComponents/notAchieveCoupon.vue